export default __webpack_public_path__ + "static/media/b-8.ade51fe9.png";